import { useState } from 'react';
import { Box, Button, Grid, Skeleton, Theme, Typography } from "@mui/material"
import { DownwardIcon, UpwardIcon } from "../../../assets/SvgIcons"
import { NO_DATA_AVAILABLE } from '../../../utils/constant';

interface OtherFundsManagedProps {
    name: string;
}
interface FundManagerProps {
    name: string;
    serviceStartPeriod: string | null;
    servicePeriod: string;
    education: string;
    experience: string;
    otherFundsManaged: Array<OtherFundsManagedProps>
}
export default function FundManagerDetails({ fundManager, loading }: { fundManager: FundManagerProps, loading: boolean }): JSX.Element {
    const [viewMoreDetails, setViewMoreDetails] = useState(false);
    return (

        <>
            <Box component={'div'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px 0' }}>
                <Box>
                    {loading ?
                        <Skeleton animation="wave" />
                        :
                        <Typography variant='body_500' sx={{ color: 'text.primary' }}>
                            {fundManager?.name}
                        </Typography>
                    }
                    {loading ?
                        <Box>
                            <Skeleton animation="wave" height={'20px'} width={'150px'} />
                        </Box>
                        :
                        <Typography variant='subtitle_500' sx={{ color: 'text.secondary' }}>
                            {`${fundManager?.serviceStartPeriod || 'N/A'} - ${fundManager?.servicePeriod || "N/A"}`}
                        </Typography>
                    }
                </Box>
                <Box>
                    {loading ? <Box>
                        <Skeleton animation="wave" variant='rectangular' height={'30px'} width={'100px'} />
                    </Box> : <Button sx={{ cursor: 'pointer' }} onClick={() => setViewMoreDetails(!viewMoreDetails)}>
                        <Typography variant='body_500' sx={(theme: Theme) => (
                            {
                                color: theme.palette.primary[500],
                                mr: '4px'
                            }
                        )}>View Details</Typography>
                        {viewMoreDetails ? <UpwardIcon /> : <DownwardIcon />}

                    </Button>}
                </Box>


            </Box>
            {
                viewMoreDetails && <>
                    <Box sx={{ padding: '0 0 15px 0' }}>
                        <Typography variant='body_500' sx={(theme: Theme) => (
                            { color: theme.palette.primary[500], mb: '10px' }
                        )}>Education</Typography>
                        <Typography variant='body_500' sx={(theme: Theme) => (
                            { color: theme.palette.text.secondary }
                        )}>{fundManager?.education || NO_DATA_AVAILABLE}</Typography>
                    </Box>
                    <Box sx={{ padding: '0 0 15px 0' }}>
                        <Typography variant='body_500' sx={(theme: Theme) => (
                            { color: theme.palette.primary[500], mb: '10px' }
                        )}>Experience</Typography>
                        <Typography variant='body_500' sx={(theme: Theme) => (
                            { color: theme.palette.text.secondary }
                        )}>{fundManager?.experience || NO_DATA_AVAILABLE}</Typography>
                    </Box>
                    <Box sx={{ padding: '0 0 15px 0' }}>
                        <Typography variant='body_500' sx={(theme: Theme) => (
                            { color: theme.palette.primary[500], mb: '10px' }
                        )}>Also Manages</Typography>

                        {fundManager?.otherFundsManaged?.length ?
                            <Grid
                                container
                                justifyContent={'space-between'}
                                spacing={2}
                                sx={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    m: { xs: 0 }
                                }}
                            >
                                {fundManager?.otherFundsManaged?.map((fundName: OtherFundsManagedProps, index: number) => (
                                    <Grid
                                        key={index}
                                        item xs={12} sm={6}
                                        textAlign={'left'}
                                    >
                                        <Typography
                                            component="span"
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '8px',
                                                color: theme.palette.text.secondary,
                                                lineHeight: '1.5',
                                                wordBreak: 'break-word',
                                            })}
                                        >
                                            <span style={{ whiteSpace: 'nowrap' }}>•</span>
                                            <span>{fundName}</span>
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>

                            :
                            <Typography
                                variant='body_500'
                                sx={(theme: Theme) => (
                                    { color: theme.palette.text.secondary, mt: '10px' }
                                )}
                            >
                                {NO_DATA_AVAILABLE}
                            </Typography>
                        }


                    </Box>

                </>
            }
        </>
    )
}

